import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../i18n";
const ExportRequestsExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Requests");
  const t = i18n.t.bind(i18n);
  worksheet.columns = [
    { header: t("requestManagement.tableHeaders.id"), key: "id", width: 10 },
    { header: t("requestManagement.tableHeaders.type"), key: "type", width: 20 },
    { header: t("requestManagement.tableHeaders.reasonCode"), key: "reasonCode", width: 18 },
    { header: t("requestManagement.tableHeaders.reason"), key: "reason", width: 30 },
    { header: t("requestManagement.tableHeaders.date"), key: "date", width: 18 },
    { header: t("requestManagement.tableHeaders.comments"), key: "comments", width: 25 },
    { header: t("requestManagement.tableHeaders.status"), key: "status", width: 15 }
  ];

  const translatedData = data.map((row) => ({
    ...row,
    status: t(`statuses.${row.status}`),
  }));

  worksheet.addRows(translatedData);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Requests_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportRequestsExcel;
